// Backend URL
//export const API_BASE_URL = '//localhost:9000'; //Local
export const API_BASE_URL = 'https://www.jettyapps.com:9000'; //Live with Jettyapps
// export const API_BASE_URL = 'https://www.jettyapps.com:9002'; //Staging Qbo


// Frontend URL 
export const FRONTEND_BASE_URL = 'https://connector.jettyapps.com/#/'; //Live with Jettyapps
// export const FRONTEND_BASE_URL = 'https://stagingconnector.jettyapps.com/#/'; //Staging Qbo


export const QBO_APP_BASE_URL = 'https://qbo.kickstarthq.com/'; //Live with Jettyapps
// export const QBO_APP_BASE_URL = 'https://stagingqbo.kickstarthq.com/'; //Staging Qbo


//export const FTP_PATH = '../var/www/connector/kickstarthq.com/html/'; //Live
//export const FTP_PATH = '../var/www/staging/connector/kickstarthq.com/html/'; //Staging
